export const SUPERADMIN_USER_ID = 1;
